<div id="mathContent" class="katex-container">
    <!-- KaTeX content will be rendered here -->
  </div>